/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveEmergencyContactAuthIdsRequest
 */
export interface RemoveEmergencyContactAuthIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof RemoveEmergencyContactAuthIdsRequest
     */
    auth_ids: Array<string>;
}

/**
 * Check if a given object implements the RemoveEmergencyContactAuthIdsRequest interface.
 */
export function instanceOfRemoveEmergencyContactAuthIdsRequest(value: object): value is RemoveEmergencyContactAuthIdsRequest {
    if (!('auth_ids' in value) || value['auth_ids'] === undefined) return false;
    return true;
}

export function RemoveEmergencyContactAuthIdsRequestFromJSON(json: any): RemoveEmergencyContactAuthIdsRequest {
    return RemoveEmergencyContactAuthIdsRequestFromJSONTyped(json, false);
}

export function RemoveEmergencyContactAuthIdsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveEmergencyContactAuthIdsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'auth_ids': json['auth_ids'],
    };
}

export function RemoveEmergencyContactAuthIdsRequestToJSON(json: any): RemoveEmergencyContactAuthIdsRequest {
    return RemoveEmergencyContactAuthIdsRequestToJSONTyped(json, false);
}

export function RemoveEmergencyContactAuthIdsRequestToJSONTyped(value?: RemoveEmergencyContactAuthIdsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'auth_ids': value['auth_ids'],
    };
}

